import { useEffect, useState } from 'react'

import useGetAgentCentralized from '~/features/agents/hooks/useGetAgentCentralized'
import { getStringFromAgentFacts } from '~/features/agents/utils'
import {
  EConvoOptionsKeys,
  EKnowledgeV1Keys,
  ESettingsStepFriendlyNames,
} from '~/features/settings/models'
import {
  ECTAValues,
  ELocationTypeValues,
  EPersonalityFriendlyName,
  EScheduleValues,
  personalityMapping,
} from '~/models/features'
import { sessionStore, store } from '~/store'

// todo: throw out settings in favor of centralized agent data. Then remove this file.
export default function useSetSettingsSteps(): boolean {
  const [settings, setSettings] = store((state) => [
    state.settings,
    state.setSettings,
  ])

  const agentId = sessionStore((state) => state.agent.id) || ''

  const {
    selectedAgent: agent,
    isSuccess,
    isLoading: isLoadingAgent,
  } = useGetAgentCentralized()

  const isSettingsAlreadySet = !!Object.entries(settings?.steps || {}).some(
    ([, value]) => !!value,
  )
  const [isLoadingAgentData, setIsLoadingAgentData] =
    useState<boolean>(!isSettingsAlreadySet)

  useEffect(() => {
    if (!isLoadingAgent && isSuccess) {
      const personality: EPersonalityFriendlyName =
        EPersonalityFriendlyName.professional

      const updatedConvoOptionsData = {
        [EConvoOptionsKeys.agentName]: agent?.agentName || '',
        [EConvoOptionsKeys.cta]: agent?.cta || ECTAValues.schedule,
        [EConvoOptionsKeys.calendlyLink]: agent?.calendlyLink || '',
        [EConvoOptionsKeys.locationType]:
          agent?.locationType || ELocationTypeValues.anywhere,

        [EConvoOptionsKeys.ctaText]: agent?.ctaText || null,
        [EConvoOptionsKeys.scheduleType]:
          agent?.scheduleType || EScheduleValues.askForAvailability,

        [EConvoOptionsKeys.location]: agent?.location || '',
        [EConvoOptionsKeys.questions]: agent?.questions || [],
        [EConvoOptionsKeys.pricing]: agent?.pricing || '',
        [EConvoOptionsKeys.personality]:
          agent?.personality || personalityMapping[personality],
        [EConvoOptionsKeys.customInstructions]: agent?.customInstructions || [
          {},
        ],
      }

      const updatedKnowledgeData = {
        [EKnowledgeV1Keys.facts]: getStringFromAgentFacts(agent?.facts),
      }

      setSettings({
        steps: {
          [ESettingsStepFriendlyNames.convoOptions]: updatedConvoOptionsData,
          [ESettingsStepFriendlyNames.knowledge]: updatedKnowledgeData,
        },
      })

      setIsLoadingAgentData(false)
    }
  }, [agent, isSuccess, isLoadingAgent, setSettings])

  return isLoadingAgentData && !!agentId && !isLoadingAgent
}
